import * as React from 'react';
import { SVGProps } from 'react';

const SvgBaby = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M16.44 17.474a7.011 7.011 0 1 1 10.663-3.99 4.81 4.81 0 0 1-1.213 1.993"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M20.208 4.94a3.445 3.445 0 0 1 3.445-3.44m-9.153 27 12.494-14.309m-12.967.14a2.705 2.705 0 0 0-2.705 2.705v10.821a9.018 9.018 0 0 0 18.035 0v-10.82a2.705 2.705 0 0 0-2.705-2.706"
    />
    <path
      fill={props.fill}
      d="M10.5 16.626v4.455h7.626l4.418-4.423-12.044-.032Z"
    />
  </svg>
);

export default SvgBaby;
